import { AbstractControl } from '@angular/forms';

import moment from 'moment';
import { isNil } from 'src/utils/utils';

export class EndDateValidator {
  static endDateValidator(control: AbstractControl) {
    const fg = control.parent;

    if (!isNil(fg)) {
      const endless = fg.get('endless')?.value;

      const dateTo = control.value;
      const dateFrom = fg.get('dateFrom')?.value;
      if (!isNil(endless) && !endless) {
        if (
          !moment(dateTo).isValid() ||
          moment(dateTo).isBefore(moment(dateFrom))
        ) {
          return { endDateValidator: true };
        }
      }
    }

    return null;
  }

  static groupValidator(fg: AbstractControl) {
    const dateToCtrl = fg.get('dateTo');
    const endless = fg.get('endless')?.value;
    const dateTo = dateToCtrl?.value;
    const dateFrom = fg.get('dateFrom')?.value;

    if (endless === false) {
      if (
        !moment(dateTo).isValid() ||
        moment(dateTo).isBefore(moment(dateFrom))
      ) {
        dateToCtrl?.setErrors({ endDateValidator: true });
        return { endDateValidator: true };
      }
    }

    dateToCtrl?.setErrors(null);
    return null;
  }
}
